export default __webpack_public_path__ + "static/keyImage-4ccb91c0439eac60f87fcb0b664e124c.webp";